module.exports = __webpack_public_path__ + "img/76340.e6858b57.svg";